import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="container py-8">
        <Button
          variant="ghost"
          className="mb-4"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        <div className="prose prose-sm md:prose-base lg:prose-lg dark:prose-invert max-w-none">
          <h1>Newsletter Terms of Service</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>

          <h2>1. Newsletter Subscription</h2>
          <p>By subscribing to our EV industry newsletter, you agree to:</p>
          <ul>
            <li>Receive regular updates about the EV industry</li>
            <li>Provide accurate subscription information</li>
            <li>Not share access to subscriber-only content</li>
            <li>Accept our email delivery frequency</li>
          </ul>

          <h2>2. Content and Intellectual Property</h2>
          <p>Our newsletter content:</p>
          <ul>
            <li>Is protected by copyright</li>
            <li>Is for personal or internal business use only</li>
            <li>Cannot be redistributed without permission</li>
            <li>May include market analysis and predictions</li>
          </ul>

          <h2>3. Subscriber Responsibilities</h2>
          <p>As a subscriber, you agree to:</p>
          <ul>
            <li>Maintain the security of your subscription</li>
            <li>Not share subscriber-only content publicly</li>
            <li>Update your contact information as needed</li>
            <li>Use the content in compliance with these terms</li>
          </ul>

          <h2>4. Disclaimer</h2>
          <p>Please note that:</p>
          <ul>
            <li>Newsletter content is for informational purposes only</li>
            <li>Market analysis and predictions are not financial advice</li>
            <li>We strive for accuracy but cannot guarantee it</li>
            <li>Individual results may vary</li>
          </ul>

          <h2>5. Subscription Management</h2>
          <p>We reserve the right to:</p>
          <ul>
            <li>Modify newsletter frequency</li>
            <li>Update these terms with notice</li>
            <li>Terminate subscriptions for violations</li>
            <li>Change our content strategy</li>
          </ul>

          <h2>6. Contact</h2>
          <p>For questions about these terms:</p>
          <p>Email: newsletter-terms@example.com</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;